import React, { useState, useEffect } from 'react';

const TaskGroupContact = ({ taskGroupName, fallbackText, contactRole }) => {
  const [contactPerson, setContactPerson] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        const allMembers = [
          ...(data.boardMembers || []),
          ...(data.honoraryMembers || [])
        ];
        let candidate = null;
        if (contactRole) {
          candidate = allMembers.find(m => m.role === contactRole && m.email);
        } else {
          const tgMembers = allMembers.filter(
            m => m.taskGroups && m.taskGroups.includes(taskGroupName) && m.email
          );
          candidate = tgMembers[0] || null;
        }
        setContactPerson(candidate);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [taskGroupName, contactRole]);

  if (loading) return null;

  const email = contactPerson?.email || 'info@ebta.eu';
  const name = contactPerson?.name;

  return (
    <div style={{
      marginBottom: '3rem',
      padding: '2rem',
      backgroundColor: '#f1f5f9',
      borderRadius: '16px',
      border: '1px solid #e2e8f0',
      textAlign: 'center'
    }}>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.25rem'}}>
        <div style={{fontSize: '2rem', marginRight: '0.75rem'}}>✉️</div>
        <h2 style={{fontSize: '1.6rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>
          Contact this Task Group
        </h2>
      </div>
      <p style={{fontSize: '1.05rem', color: '#64748b', marginBottom: '1.75rem', maxWidth: '600px', margin: '0 auto 1.75rem'}}>
        {fallbackText || 'Have a question or want to get involved? Reach out to the task group directly.'}
      </p>
      <a
        href={`mailto:${email}`}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          backgroundColor: '#2563eb',
          color: 'white',
          padding: '0.9rem 1.75rem',
          borderRadius: '10px',
          textDecoration: 'none',
          fontWeight: '600',
          fontSize: '1rem',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#1d4ed8';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#2563eb';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <span style={{marginRight: '0.5rem'}}>📧</span>
        {name ? `Email ${name}` : 'Email the Task Group'}
      </a>
      {name && (
        <p style={{fontSize: '0.9rem', color: '#94a3b8', marginTop: '1rem', marginBottom: 0}}>
          {name} is the contact person for this task group.
        </p>
      )}
    </div>
  );
};

export default TaskGroupContact;
